export default "__VITE_ASSET__BTxTNTAg__"